<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiFilter.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrIsoIcTetkik from "@/models/StrIsoIcTetkik";
//import moment from "moment";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import Treeselect from "@riophae/vue-treeselect";

export default {
  mixins: [Api, Sabit, StrIsoIcTetkik],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      Personeller: [],
      aktif_arama: false,
    };
  },
  components: {
    Loader, BirimSecimi, forminput, Treeselect
  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.secili_personel_yukle();
    },
  },
  methods: {
    onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) {
        if (this.AddEdit == "Add") {
          // this.FormData.Tarih = moment(new Date()).format("YYYY-MM-DD");
          // this.FormData.Saat = moment(new Date()).format("HH:mm");
          this.Post("StrIsoIcTetkik", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.StrIsoIcTetkikData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIsoIcTetkik");
            }
          });
        } else {
          this.Update("StrIsoIcTetkik", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrIsoIcTetkikData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrIsoIcTetkik");
            }
          });
        }
      }
    },
    Get() { },

    async secili_personel_yukle() {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };
      this.aktif_arama = false;
      this.Personeller = [];
      for (let index = 0; index < this.FormData.Birimpersonelleriids.length; index++) {
        const element = this.FormData.Birimpersonelleriids[index];
        const res = await this.ActionsGet({ Service: "OPersonel/" + element, Page });
        const exists = this.Personeller.some(p => p.id === res.Data.Id);
        if (!exists) {
          this.Personeller.push({
            id: res.Data.Id,
            label: res.Data.Adsoyad
          });
        }
      }
      for (let index = 0; index < this.FormData.Ictetkikciids.length; index++) {
        const element = this.FormData.Ictetkikciids[index];
        const res = await this.ActionsGet({ Service: "OPersonel/" + element, Page });
        const exists = this.Personeller.some(p => p.id === res.Data.Id);
        if (!exists) {
          this.Personeller.push({
            id: res.Data.Id,
            label: res.Data.Adsoyad
          });
        }
      }

    },

    async personel_yukle(veri) {
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      this.aktif_arama = true;

      if (veri.length >= 1) {
        this.Personeller = [];

        let Filter = "&Adsoyad=" + veri + "&Asc=AdSoyad";
        let res = await this.ActionsFilterGet({ Service: "OPersonel", Page: Page, Filter: Filter });

        this.Personeller = res.Data.map(item => ({
          id: item.Id,
          label: item.Adsoyad
        }));

        this.aktif_arama = false;
      }
    },


    personel_loadOptions({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery.length > 0) {
        this.personel_yukle(searchQuery).then(() => {
          callback(null, this.Personeller);
        });
      } else {
        callback(null, []);
      }
    }


  },
};
</script>
<template>
  <Loader>
    <b-modal id="StrIsoIcTetkik" size="lg" :title="this.AddEdit == 'Edit'
      ? 'Kaydı Düzenle'
      : 'Kayıt Ekle'
      " title-class="font-18" hide-footer>
      <Form @submit.prevent="onSubmit">
        <div class="row">
 
          <BirimSecimi class="mb-3 col-md-6" :title="FormDataType.Birimid.FieldTitle" :sutun="'0'"
            :title_position="'mb-3'" :selected="FormData.Birimid" :labels_lg="'3'" :v="$v.FormData.Birimid"
            :multiple="false" :BirimTipId="null" @Secilmis_Idler="FormData.Birimid = $event" />

          <forminput class="col-md-6" :FormDataType="FormDataType.Yer" :Value="FormData.Yer" :v="$v.FormData.Yer"
            @input="FormData.Yer = $event" />

          <b-form-group class="mb-3 col-md-6" label="Tetkike Katılan Birim Personeli" label-for="text">
            <treeselect :load-options="personel_loadOptions" :multiple="true" :async="true" :searchable="true"
              :clearable="true" :value="FormData.Birimpersonelleriids" placeholder="Seçiniz..."
              v-model="FormData.Birimpersonelleriids" />
          </b-form-group>

          <b-form-group class="mb-3 col-md-6" label="İç Tetkikçi" label-for="text">
            <treeselect :load-options="personel_loadOptions" :multiple="true" :async="true" :searchable="true"
              :clearable="true" :value="FormData.Ictetkikciids" placeholder="Seçiniz..."
              v-model="FormData.Ictetkikciids" />

          </b-form-group>


        </div>
        <button class="btn btn-primary " type="submit">
          Kaydet
        </button>
      </Form>
    </b-modal>
  </Loader>
</template>
